export default {
  iosUrl: "itms-services://?action=download-manifest&url=https://asset.lnyuanyikj.xyz/app/tcly/tcly.plist",
  androidUrl: "http://asset.lnyuanyikj.xyz/app/tcly/tcly.apk",
  apiDomain: "https://www.lnyuanyikj.xyz",
  sharePrefix: "#tcly#",
};
